import { fetchCA } from 'helpers/utils'

export const apiFetchFaqs = (categoryId, phoneId) =>
  fetchCA('/faqs', { categoryId, phoneId })

export const apiFetchCategories = (phoneId) =>
  fetchCA('/categories', { phoneId })
